import { captureEvent } from "@/lib/analytics";
import {
  isMarketplaceModalAnalyticsActive,
  marketplaceModalAbandonOnNavigationAway,
  marketplaceModalOpened,
} from "@/lib/marketplaceModalAnalytics";
import type { MarketplaceKey } from "@/marketplaces/registry";

let onboardingViewTracked = false;

/** Экран онбординга смонтирован (выбор маркетплейса после регистрации). */
export function onboardingScreenViewed(): void {
  if (onboardingViewTracked) return;
  onboardingViewTracked = true;

  captureEvent("[CardGenius] Показ экрана онбординга", {
    is_mobile_viewport: typeof window !== "undefined" && window.innerWidth < 640,
  });

  marketplaceModalOpened("onboarding");
}

export function onboardingScreenHidden(reason: "completed" | "navigation_away"): void {
  onboardingViewTracked = false;
  if (reason === "navigation_away" && isMarketplaceModalAnalyticsActive()) {
    marketplaceModalAbandonOnNavigationAway();
  }
}

export function onboardingCompleted(marketplace: MarketplaceKey, timeOnScreenMs: number): void {
  captureEvent("[CardGenius] Завершение онбординга", {
    marketplace,
    time_on_screen_ms: timeOnScreenMs,
    is_mobile_viewport: typeof window !== "undefined" && window.innerWidth < 640,
  });
}
